import React from "react";

import {
  Document, Page, View, StyleSheet, Font, Text,
} from "@react-pdf/renderer";

import RobotoMedium from "../../../../../assets/fonts/roboto/Roboto-Medium.ttf";
import Roboto from "../../../../../assets/fonts/roboto/Roboto-Regular.ttf";
import { buildExportHeaders, buildExportRow } from "./swabListExportUtils";

const COLUMN_WIDTHS = ["28%", "16%", "16%", "20%", "20%"];

export default function SwabListPDF({
  swabList = [],
  tableHeaders = [],
  testsColumnLabel = "Tests Out of Spec",
  finalResultColumnLabel = "",
  modalTitle = "Sample List",
  dateRange = "",
  includeReceivedDate = true,
  getFileName,
}) {
  Font.register({ family: "Roboto-400", src: Roboto });
  Font.register({ family: "Roboto-500", src: RobotoMedium });

  const headers = buildExportHeaders({
    tableHeaders,
    testsColumnLabel,
    finalResultColumnLabel,
    includeReceivedDate,
  });

  const styles = StyleSheet.create({
    page: {
      display: "flex",
      flexDirection: "column",
      backgroundColor: "#FFFFFF",
      padding: "36 36 24 36",
      color: "#1B1F1E",
      fontFamily: "Roboto-400",
      fontSize: 10,
    },
    title: {
      fontFamily: "Roboto-500",
      fontSize: 14,
      marginBottom: 8,
    },
    dateRange: {
      fontSize: 10,
      color: "#6F7A76",
      marginBottom: 20,
    },
    dateRangeValue: {
      color: "#1B1F1E",
      fontFamily: "Roboto-500",
    },
    table: {
      border: "1 solid #E0E6E3",
      borderRadius: 6,
      overflow: "hidden",
    },
    tableHeaderRow: {
      display: "flex",
      flexDirection: "row",
      backgroundColor: "#F1F5F3",
    },
    tableRow: {
      display: "flex",
      flexDirection: "row",
    },
    headerCell: {
      padding: "10 12",
      fontFamily: "Roboto-500",
      fontSize: 10,
      borderRight: "1 solid #E0E6E3",
    },
    cell: {
      padding: "10 12",
      fontSize: 10,
      borderRight: "1 solid #E0E6E3",
      wordBreak: "break-word",
    },
    headerCellLast: { borderRight: "0" },
    cellLast: { borderRight: "0" },
  });

  const getColumnWidth = (index) => (
    COLUMN_WIDTHS[index] ?? `${Math.floor(100 / headers.length)}%`
  );

  return (
    <Document title={getFileName()}>
      <Page size="LETTER" style={styles.page}>
        <Text style={styles.title}>{modalTitle}</Text>
        <Text style={styles.dateRange}>
          Date Range :
          {" "}
          <Text style={styles.dateRangeValue}>{dateRange || "-"}</Text>
        </Text>
        <View style={styles.table}>
          <View style={styles.tableHeaderRow} fixed>
            {headers.map((header, index) => (
              <Text
                key={header}
                style={[
                  styles.headerCell,
                  { width: getColumnWidth(index) },
                  index === headers.length - 1 ? styles.headerCellLast : null,
                ]}
              >
                {header}
              </Text>
            ))}
          </View>
          {swabList.map((row, index) => {
            const cells = buildExportRow(row, {
              tableHeaders,
              includeReceivedDate,
              finalResultColumnLabel,
            });

            return (
              <View key={`${row.sample_id}-${index}`} style={styles.tableRow} wrap={false}>
                {cells.map((cell, cellIndex) => (
                  <Text
                    key={`${row.sample_id}-${cellIndex}`}
                    style={[
                      styles.cell,
                      { width: getColumnWidth(cellIndex) },
                      cellIndex === cells.length - 1 ? styles.cellLast : null,
                    ]}
                  >
                    {cell ?? "-"}
                  </Text>
                ))}
              </View>
            );
          })}
        </View>
      </Page>
    </Document>
  );
}
